import { useContext } from 'react';
import { ViewContext } from '@contexts/ViewContext';

// returning all updated data from out context with useContext hook
// from now we are going to use useView custom hook everywhere were we will need data from context,
// to not import everywhere { useContext }
const useView = () => useContext(ViewContext);

export default useView;
